// import { Theme, useTheme } from "../helpers/ThemeProvider";
import headerImage from '../images/Hercules_head_cropped_300px.png';
import { FaMoon, FaSun } from 'react-icons/fa';
import useMediaQuery from '../helpers/useMediaQuery';
import { Link } from 'react-router';
import { useTheme } from '../helpers/ThemeContext';

export default function Header() {
  const { theme, toggleTheme } = useTheme();
  const matches = useMediaQuery('screen and (max-width: 640px)');

  return (
    <header
      className='min-h-[200px] bg-light-header-color
     dark:bg-transparent dark:text-gray-300'
    >
      <div className="flex justify-between ps-12 pt-6 font-['Russo_One'] text-4xl sm:text-5xl">
        {matches ? 'Alpaca' : 'Alpaca Tracker'}
        <div className=' px-4'>
          <button onClick={toggleTheme} title='Change Theme'>
            {theme == 'dark' ? (
              <div className='flex items-center'>
                <FaSun className='ps-3 text-3xl' />
              </div>
            ) : (
              <div className='flex items-center'>
                <FaMoon className='ps-3 text-3xl' />
              </div>
            )}
          </button>
        </div>
      </div>

      <div className='flex justify-center'>
        <Link to='/'>
          <img
            src={headerImage}
            alt='alpaca'
            className='m-4 h-[140px] ps-6 sm:h-[150px] sm:ps-0'
          />
        </Link>
      </div>

      {matches && (
        <div className="flex justify-end self-end pb-6 pe-12 font-['Russo_One'] text-4xl sm:text-5xl">
          Tracker
        </div>
      )}
    </header>
  );
}
